import React from "react";
import { cn } from "@/lib/utils";

export const KRAYA_LOGO_PATH = "/assets/brand/kraya-logo-primary.png";
export const KRAYA_LOGO_ON_DARK_PATH = "/assets/brand/kraya-logo-on-dark.png";

const SIZE_CLASS = {
  sm: "w-[88px]",
  md: "w-[109px]",
  lg: "w-[132px]",
};

/**
 * Single visual source of truth for the KRAYA. logo.
 *
 * variant="default" uses the approved dark wordmark + blue dot for light
 * backgrounds. variant="on-dark" uses the white wordmark + the same blue
 * dot for dark backgrounds. `accentClassName` is retained only for backward
 * compatibility with older call sites and never changes logo colors.
 */
export default function BrandMark({
  className,
  accentClassName: _accentClassName,
  size = "md",
  variant = "default",
  ...props
}) {
  const onDark = variant === "on-dark" || variant === "dark";
  const logoPath = onDark ? KRAYA_LOGO_ON_DARK_PATH : KRAYA_LOGO_PATH;

  return (
    <span
      className={cn("inline-flex shrink-0 items-center", className)}
      aria-label="KRAYA."
      {...props}
    >
      <img
        src={logoPath}
        alt="KRAYA."
        className={cn("block h-auto max-w-none select-none object-contain", SIZE_CLASS[size] || SIZE_CLASS.md)}
        draggable="false"
        width="109"
        height="41"
      />
    </span>
  );
}
